import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h5>{`關於松凌`}</h5>
    <p>{`松凌科技成立於 2002 年，目前已經是台灣金融資訊服務業中技術領先的領導廠商之一。 服務客戶包含了銀行、保險等金融機構，主要解決方案為 JavaEE 企業端應用。提供了最專業的顧問服務，系統分析整合，程式開發測試等等，並且專注於交易與安全性的設計，替客戶建立起最完整的系統。`}</p>
    <h5>{`松凌的願景`}</h5>
    <p>{`應用最先進的技術與產品，成為台灣最優秀的資訊軟體服務廠商，並且培養軟體開發人才，提升台灣軟體業在國際上的競爭能力與地位。`}</p>
    <h5>{`松凌的使命`}</h5>
    <p>{`致力於軟體創新的研發與應用，協助客戶解決問題與創造優勢，成為台灣軟體資訊服務廠商中，值得長期信賴的技術及服務提供者。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      